import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import MasterListReportFormat2 from './MasterListReportFormat2';

function MasterListReportFormat2Wrapper() {

    const location = useLocation();
    const [showComponent, setShowComponent] = useState(true);

    useEffect(() => {

        console.log("location.search", location.search)
        setShowComponent(false);
        const timeout = setTimeout(() => {
            setShowComponent(true);
        }, 10); // short delay forces unmount/remount

        return () => clearTimeout(timeout);
    }, [location.search]);

    return showComponent ? <MasterListReportFormat2 /> : <div></div>;
}

export default MasterListReportFormat2Wrapper;